<!--
 * @Author: your name
 * @Date: 2020-07-02 15:13:19
 * @LastEditTime: 2020-12-16 17:26:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\views\index\index.vue
--> 
<template>
  <div class="index">
    <div class="main">
      <div class="bg">
        <img src="@/assets/images/index/tame_bg.jpg" alt />
        <div class="person p1"  @mouseover.stop="changeActive(1)">
          <img class="pic_p" src="@/assets/images/index/sx.png" alt="">
          <img v-if="active == 1" class="pic_w" src="@/assets/images/index/team-sx.png" alt="">
        </div>
        <div class="person p2"  @mouseover.stop="changeActive(2)">
          <img class="pic_p" src="@/assets/images/index/yw.png" alt="">
          <img v-if="active == 2" class="pic_w" src="@/assets/images/index/team-yw.png" alt="">
        </div>
        <div class="person p3"  @mouseover.stop="changeActive(3)">
          <img class="pic_p" src="@/assets/images/index/yy.png" alt="">
          <img v-if="active == 3" class="pic_w" src="@/assets/images/index/team-yy.png" alt="">
        </div>
        <div class="person p4"  @mouseover.stop="changeActive(4)">
          <img class="pic_p" src="@/assets/images/index/wl.png" alt="">
          <img v-if="active == 4" class="pic_w" src="@/assets/images/index/team-wl.png" alt="">
        </div>

        <img class="line-sx" v-if="active == 1" src="@/assets/images/index/line-sx.png" alt="">
        <img class="line-yw" v-if="active == 2" src="@/assets/images/index/line-yw.png" alt="">
        <img class="line-yy" v-if="active == 3" src="@/assets/images/index/line-yy.png" alt="">
        <img class="line-wl" v-if="active == 4"  src="@/assets/images/index/line-wl.png" alt="">

        <div class="text_box">
          <div class="text-item" v-if="active == 1">
            <div class="name">王建民</div>
            <div class="text">人民大学附属中学实验班特聘主讲教师。中国数学奥林匹克高级教师，知好乐教育研究院数学所所长。</div>
          </div>
          <div class="text-item" v-if="active == 2">
            <div class="name">王大绩</div>
            <div class="text">北京陈经纶中学语文特级教师，全国著名的高考语文辅导专家。北京市教育学会语文教学研究会常务理事，商务印书馆教育图书中心特聘研究员，《考试》杂志编委，同方知好乐教育研究院特聘专家。</div>
          </div>
          <div class="text-item" v-if="active == 3">
            <div class="name">郑宁华</div>
            <div class="text">北师大二附中英语特级教师，外语教研组组长，1995年被评为西城区学科带头人；1998年被评为北京市中青年骨干教师；1999年4月 代表北京市参加全国中学英语优质课竞赛，获全国竞赛一等奖；2005年被评为北京市特级教师。</div>
          </div>
          <div class="text-item" v-if="active == 4">
            <div class="name">马桂君</div>
            <div class="text">北京师范大学附属中学物理教师，物理教研组组长。北京师范大学教育学部研究员，北京市物理特级教师。北京物理学会竞赛委员会委员，人教版教材培训专家。</div>
          </div>
        </div>
      </div>
      <!-- <div class="bg2">
        <img src="@/assets/images/home/bg2.jpg" alt />
        <button @click="gohome">立即体验</button>
      </div> -->
      <!-- <div class="who">
        <div class="content">
          <div class="label">
            <div class="left">
              <div class="line"></div>
              <div class="point"></div>
            </div>
            <div class="text">我们是谁</div>
            <div class="right">
              <div class="point"></div>
              <div class="line"></div>
            </div>
          </div>
          <div class="major">
            <div class="left">
              <img src="@/assets/images/index/02-qinghuayuan.png" alt />
            </div>
            <div class="middle">
              <div
                class="text"
              >知好乐教育，近20年来专注于教育信息化整体解决方案、教学资源与软件产品研发、技术服务、教学研究、教育培训、教育服务等业务，致力于信息技术与学科教学融合的研究、实践与推广。多年的耕耘与积淀，知好乐形成了区域智慧教育、智慧校园、学科教学应用服务、中小学学生学习辅导、在线学习、职业教育信息化等六大业务版块，在全国已有近百家区域教育局、几千所中小学校、上百万中小学生的规模用户，是国内中小学教育信息化领域领头羊企业。集团拥有专业的教育研究院、电子出版社、培训学校及北京、上海、广东、深圳等10多家子公司。</div>
            </div>
            <div class="right">
              <img src="@/assets/images/index/02-zhl.png" alt />
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="zhl">
        <div class="content">
          <div class="label">
            <div class="left">
              <div class="line"></div>
              <div class="point"></div>
            </div>
            <div class="text">知好乐教育研究院</div>
            <div class="right">
              <div class="point"></div>
              <div class="line"></div>
            </div>
          </div>
          <div class="first">
            知好乐教育研究院（原清华同方教育技术研究院）始建于 2000 年 5 月，是专门从事基础教育、职业教育等领域教育信息化研究的教学科研和服务机构。
          </div>
          <div class="person">
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/03-01.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">首任院长：顾秉林先生</div>
                <div class="other">清华大学前任校长</div>
                <div class="other">中国科学院院士</div>
              </div>
            </div>
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/03-02.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">现任院长：兰宏生先生</div>
                <div class="other">中国联合国教科文组织联合会副主席</div>
                <div class="other">中国教育学会学术委员、原国家督学</div>
              </div>
            </div>
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/03-03.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">名誉院长：陶西平先生</div>
                <div class="other">著名教育家、国家教育咨询委员会委员、国家总督学顾问</div>
                <div class="other">联合国教科文组织协会世界联合会名誉主席</div>
              </div>
            </div>
          </div>
          <div class="bottom">
            研究院下设中小学各学科研究所、现代教育技术研究所、素质教育研究所、创新教育研究所，以及家庭教育、职业教育、学前教育、老年教育等研究所，满足对不同学科、不同学段、不同人群的教育研究，每个研究所均由本学科国内著名的特级教师或知名教授任所长。研究院设有专门的学术指导和教学质量管理机构——学术委员会，由 100 多位优秀的中小学特级、高级教师以及来自清华大学、北京大学、北京师范大学等高校教授组成。
          </div>
        </div>
      </div> -->
      <!-- <div class="export">
        <div class="content">
          <div class="label">
            <div class="left">
              <div class="line"></div>
              <div class="point"></div>
            </div>
            <div class="text">实力雄厚的专家团队</div>
            <div class="right">
              <div class="point"></div>
              <div class="line"></div>
            </div>
          </div>
        <div class="first">
          研究院集聚了来自清华、北大、北师大等著名高校的学科专家、教育信息技术专家、北京名师，以及来自全国的学科骨干教师，组建了专业的研发团队与高素质的服务团队，如王大绩、顾德希、王建民、薛文叙、张玲棣、孟卫东、冬镜寰、田玉凤、林镜仁、王树声等，具备强大的研究实力与丰富的实践经验，产出了丰富的研究成果。
        </div>
        <div class="picture">
          <img src="@/assets/images/index/04.png" alt />
        </div>
        </div>
        
      </div> -->
      <!-- <div class="user">
        <div class="content">
          <div class="label">
            <div class="left">
              <div class="line"></div>
              <div class="point"></div>
            </div>
            <div class="text">用户覆盖</div>
            <div class="right">
              <div class="point"></div>
              <div class="line"></div>
            </div>
          </div>
        <div class="first">
         近二十年的耕耘与积淀，知好乐在全国已有上百家区县教育局、上千所中小学校、上百万名中小学生的规模用户，得到了众多用户广泛的认可和赞誉。
        </div>
        <div class="picture">
          <img src="@/assets/images/index/05.png" alt />
        </div>
        </div>
        
      </div> -->
      <!-- <div class="advantage">
        <div class="content">
          <div class="label">
            <div class="left">
              <div class="line"></div>
              <div class="point"></div>
            </div>
            <div class="text">我们的优势</div>
            <div class="right">
              <div class="point"></div>
              <div class="line"></div>
            </div>
          </div>
          <div class="person">
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/06-01.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">行业“老字号”</div>
                <div class="other">出身于清华大学</div>
                <div class="other">二十年厚重积淀</div>
              </div>
            </div>
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/06-02.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">专家“一对一”</div>
                <div class="other">全国著名学科专家</div>
                <div class="other">“一对一”为你解惑</div>
              </div>
            </div>
            
             <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/06-04.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">题库“独精尖”</div>
                <div class="other">独家“衡水题库”</div>
                <div class="other">精确瞄准高考动向</div>
              </div>
            </div>
            <div class="item">
              <div class="picture">
                <img src="@/assets/images/index/06-03.png" alt="">
              </div>
              <div class="introduce">
                <div class="identity">提分“就靠它”</div>
                <div class="other">困惑迎刃而解</div>
                <div class="other">提分轻松拿下</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="number">
        <div class="content">
        <div class="item">
          <div class="top">
          65<span>个</span>
          </div>
          <div class="bottom">
            城市
          </div>
        </div>
        <div class="item">
          <div class="top">
            120<span>万</span>
          </div>
          <div class="bottom">
            高考生
          </div>
        </div>
        <div class="item">
          <div class="top">
            4<span>万</span>
          </div>
          <div class="bottom">
            学校
          </div>
        </div>
        </div>
      </div> -->

      <el-dialog
        title="完善信息"
        :visible.sync="centerDialogVisible"
        height="auto"
        center
        custom-class="dialog_visible"
        @close="closeDialog">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="form_user">
            <el-form-item label="账号" prop="username">
              <el-tooltip class="item" effect="dark" content="账号长度为6-20,不能为纯数字,可使用字母、数字、_" placement="top">
                <el-input v-model="ruleForm.username" maxlength="20" placeholder="密码和账号默认一致"></el-input>
              </el-tooltip>
            </el-form-item>
            <!-- <el-form-item label="密码" prop="pass">
              <el-tooltip class="item" effect="dark" content="密码长度为6-20,可使用字母、数字、_" placement="top">
                <el-input type="password" maxlength="20" v-model="ruleForm.pass" placeholder="请输入密码" autocomplete="off"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="确认密码" maxlength="20" prop="confirm_pass">
              <el-tooltip class="item" effect="dark" content="密码长度为6-20,可使用字母、数字、_" placement="top">
                <el-input type="password" v-model="ruleForm.confirm_pass" placeholder="请确认密码" autocomplete="off"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <el-form-item label="选择省份" prop="province">
              <el-select v-model="ruleForm.province" placeholder="请选择省份" @change="getTypeByProv">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label prop="soa" v-if="gkType == 0">
              <div class="csoa">
                <div class="tip">请选择文/理科</div>
                <div>
                  <el-radio-group v-model="ruleForm.soa">
                    <el-radio label="理科"></el-radio>
                    <el-radio label="文科"></el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item label prop="checkList" v-if="gkType == 1">
              <div class="csoa">
                <div class="tip">请选择学科</div>
                <div>
                  <el-checkbox-group v-model="ruleForm.checkList" :max="6">
                    <el-checkbox label="语文" disabled></el-checkbox>
                    <el-checkbox label="数学" disabled></el-checkbox>
                    <el-checkbox label="英语" disabled></el-checkbox>
                    <el-checkbox label="物理"></el-checkbox>
                    <el-checkbox label="化学"></el-checkbox>
                    <el-checkbox label="生物"></el-checkbox>
                    <el-checkbox label="政治"></el-checkbox>
                    <el-checkbox label="历史"></el-checkbox>
                    <el-checkbox label="地理"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item label="学校名称" prop="school">
              <el-tooltip class="item" effect="dark" content="学校名称最长为20" placement="top">
                <el-input v-model="ruleForm.school" placeholder="请输入学校名称" maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <!-- <el-form-item label="真实姓名" prop="name">
              <el-tooltip class="item" effect="dark" content="姓名长度为2-20" placement="top">
                <el-input v-model="ruleForm.name" placeholder="请输入真实姓名" maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <el-form-item label prop="agree">
              <el-checkbox v-model="ruleForm.agree">同意</el-checkbox>
              <a target="_blank" href="#/register/argeement">用户协议</a>
            </el-form-item>
          </div>
          <el-form-item label>
            <el-button type="primary" :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}" :disabled="isDisabled" @click="submitForm('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <!-- <div class="foot">
      <div class="content">
      <div class="left">
        <div class="logo">
          <img src="@/assets/images/header/logo.png" alt="">
        </div>
        <div class="name">北京尚壹本科技有限公司</div>
        <div class="copyright" v-html="'Copyright 版权所有 &nbsp;&nbsp; 北京尚壹本科技有限公司&nbsp;&nbsp; 京ICP备10003979号-1'"></div>
      </div>  
      <div class="right">
        <div class="qrcode">
          <img src="@/assets/images/index/qrcode.png" alt="">
        </div>
        <div class="text">
          <p>关注我们</p>
          <p>联系我们</p>
        </div>
      </div>
      </div>
    </div> -->
    <input type="text" @keyup.enter="ls">
  </div>
</template>

<script>
import Header from "@/components/header/header";
import high_school_subjcet from "@/assets/js/subject-data.js";
import Login from "VIEWS/login/login";
export default {
  name: "index",
  components: {
    Header,
  },
  data() {
    let valid_num = /^\d+$/g;
    let valid_no_chinese = /^[^\u4e00-\u9fa5]+$/g;
    var choose_subject = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请至少选择六科"));
      } else {
        callback();
      }
    };
    var agree_is = (rule, value, callback) => {
      if (!this.ruleForm.agree) {
        callback(new Error("请同意用户协议"));
      } else {
        callback();
      }
    };
    var un_is_nan = (rule, value, callback) => {
      if (value.match(valid_num)) {
        callback(new Error("账号不能为纯数字"));
      } else if (!value.match(valid_no_chinese)) {
        callback(new Error("账号不能输入中文"));
      } else {
        this.$HTTP.executeGet(this.$APIS.USERNAME_EXISTS+this.ruleForm.username,this).then(res=>{
          if(!res.valid){
            callback(new Error("账号已存在"));
          }else{
            callback();
          }
        });
      }
    };
    return {
      active: 1,
      isRegister: false,
      code: '',
      centerDialogVisible: false,
      //渲染数据
      gkType: 0,
      //验证码相关
      timing : '获取验证码',
      generate_verify_code : '',
      isSend : false,
      countdown : 60,
      //点击注册,样式变化
      isDisabled : false,
      //点击验证码
      isSend : false,
      //用户名是否存在
      isEx : false,
      ruleForm: {
        //表单数据
        username: "", // 用户名
        pass: "", // 密码
        confirm_pass: "", // 确认密码
        province: "", // 省份
        checkList: ["语文", "数学", "英语"],
        soa: "",
        school: "", // 设置学校
        name: "", // 
        agree: true,
        phone : '',
        very_code : ''
      },
      //校验规则
      rules: {
        username: [
          { required: true, message: "请设置账号", trigger: "blur" },
          { min: 6, max: 20, message: "账号长度为6-20", trigger: "blur" },
          { validator: un_is_nan, trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        checkList: [{ validator: choose_subject, trigger: "change" }],
        soa: [{ required: true, message: "请选择学科", trigger: "change" }],
        // name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        agree: [
          { required: true, message: "请同意用户协议", trigger: "change" },
          { validator: agree_is, trigger: "change" },
        ]
      },
      options: [
        // {
        //   value: "100000",
        //   label: "全国"
        // },
        {
          value: "100001",
          label: "北京市",
        },
        {
          value: "100351",
          label: "天津市",
        },
        {
          value: "100676",
          label: "河北省",
        },
        {
          value: "103174",
          label: "山西省",
        },
        {
          value: "104775",
          label: "内蒙古自治区",
        },
        {
          value: "106156",
          label: "辽宁省",
        },
        {
          value: "107840",
          label: "吉林省",
        },
        {
          value: "108938",
          label: "黑龙江省",
        },
        {
          value: "110925",
          label: "上海市",
        },
        {
          value: "111176",
          label: "江苏省",
        },
        {
          value: "112869",
          label: "浙江省",
        },
        {
          value: "114332",
          label: "安徽省",
        },
        {
          value: "116110",
          label: "福建省",
        },
        {
          value: "117389",
          label: "江西省",
        },
        {
          value: "119286",
          label: "山东省",
        },
        {
          value: "121284",
          label: "河南省",
        },
        {
          value: "123998",
          label: "湖北省",
        },
        {
          value: "125608",
          label: "湖南省",
        },
        {
          value: "128268",
          label: "广东省",
        },
        {
          value: "130122",
          label: "广西壮族自治区",
        },
        {
          value: "131535",
          label: "海南省",
        },
        {
          value: "131777",
          label: "重庆市",
        },
        {
          value: "132845",
          label: "四川省",
        },
        {
          value: "137757",
          label: "贵州省",
        },
        {
          value: "139471",
          label: "云南省",
        },
        {
          value: "141031",
          label: "西藏自治区",
        },
        {
          value: "141806",
          label: "陕西省",
        },
        {
          value: "143365",
          label: "甘肃省",
        },
        {
          value: "144879",
          label: "青海省",
        },
        {
          value: "145343",
          label: "宁夏回族自治区",
        },
        {
          value: "145634",
          label: "新疆维吾尔自治区",
        },
        {
          value: "147179",
          label: "台湾省",
        },
        {
          value: "147180",
          label: "香港特别行政区",
        },
        {
          value: "147181",
          label: "澳门特别行政区",
        },
      ],
      wxData: {}, // 微信返回的基本信息
      psdstr: '',
      openId: '',
      nickname: ''
    }
  },
  methods: {
    changeActive(index) {
      this.active = index
    },
    gohome() {
      this.$root.eventHub.$emit('changePath', 'home')
      this.$router.push({
        path: '/tfedu_common/home'
      })
    },
    getRanNum() { // 随机生成8位数名字
       var result = [];
        for(var i=0;i< 10;i++){
           var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
            //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
            result.push(String.fromCharCode(65+ranNum));
        }
     return  result.join('');
    },
    getpwd() {
      var code = "";
      for(var i = 1;i <= 10;i++){
          const num = Math.floor(Math.random()*10);
          code += num;
      }
      return code
    },
    getTypeByProv() {
      let prov = this.ruleForm.province;
      this.$HTTP
        .executeGet(this.$APIS.GET_TYPE_BY_PROVINCE + prov, this)
        .then((response) => {
          this.gkType = response.gkType;
        });
    },
    closeDialog() {
      this.$message.error('基本信息设置失败, 请重新扫码登录')
      this.centerDialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          this.register_user();
        } else {
          return false;
        }
      });
    },
    getSubjects(){
      let subject_ids_str ='' ;
      let SS = this.ruleForm.checkList;
      let HSS = high_school_subjcet;
      let SISA = [];
      if(this.ruleForm.gkType == 0){
        if(this.ruleForm.soa == 0){
          this.ruleForm.checkList = ['语文','数学','英语','物理','化学','生物'];
        }else{
          this.ruleForm.checkList = ['语文','数学','英语','历史','政治','地理'];
        }
      }
      //i为键值
      for( var i in HSS){
        //j为数组索引
          for( var j in SS){
              if(HSS[i] == SS[j]){
                SISA.push(i);
              }
          }
      }
      subject_ids_str = SISA.toString();
      SISA = [];
      return subject_ids_str;
    },
    // 注册接口
    register_user() {
      let subject_ids_str = this.getSubjects();
      // this.ruleForm.username = this.openId.substring(this.openId.length - 10, this.openId.length);

      let regInfo = {
        username: this.ruleForm.username,
        password: this.ruleForm.username,
        province: this.ruleForm.province,
        school: this.ruleForm.school,
        name: this.ruleForm.name,
        subject_ids: subject_ids_str,
        nickname: this.nickname
      };
      this.$HTTP
        .executePost(this.$APIS.USER_REGISTER_USERNAME_PASSWORD, regInfo, this)
        .then((response) => {
          if (response.code != 0) {
            this.$message.error("基本信息注册错误!");
            this.isDisabled = false;
            return;
          }
          this.user_login()
          this.$router.push("/");
        });
    },
    // 登陆接口
    user_login() {
      let data = {
        username: this.ruleForm.username,
        password: this.ruleForm.username,
        openid: this.wxData.openid || ''
      };
      this.$HTTP
        .executePost(this.$APIS.USER_LOGIN, data, this)
        .then((response) => {
          if (response.msg == "Success!") {
            let userinfo = response.data;
            userinfo.password = this.password;
            var userinfo_json = JSON.stringify(userinfo);
            window.localStorage.setItem("userinfo", userinfo_json);
            this.$root.eventHub.$emit('changePath', 'home')
            this.$router.push({
              path: '/tfedu_common/home'
            })
          } else {
            this.isDisabled = false;
            this.$message.error(response.msg);
          }
        });
    },
  },
  created() {
    this.code = window.location.href.substr(1).split('&')[0].split('=')[1]
    if (this.code) { // 有值 表示微信登录
      this.$store.commit('changeIsShowLogin', false);
      this.$HTTP
        .executeGet(this.$APIS.WX_LOGIN_GET_CODE +  '?code=' + this.code, this)
        .then((response) => {
          if(response.code == 0) {
            this.wxData = response.data
            if(this.wxData.bindState == 0) { // 未绑定需要注册
              this.openId = response.data.openid
              this.nickname = response.data.nickname
              this.ruleForm.username = this.openId.substring(this.openId.length - 10, this.openId.length);
              this.centerDialogVisible = true
            } else {
              // 已经绑定 直接登录
              let userinfo = response.data;
              var userinfo_json = JSON.stringify(userinfo);
              window.localStorage.setItem('userinfo', userinfo_json);
              this.$root.eventHub.$emit('changePath', 'home')
              this.$router.push({
                path: '/tfedu_common/home'
              })
            }
          }
        });
    }
  },
  mounted() {},
};
</script>
<style lang="stylus" scoped > //  scss
.index {
  height: auto;
  width: 100%;
  background-color: #ffffff;
  position: absolute;

  .main {
    height: auto;
    width: 100%;
    background-color: #ffffff;
    position: relative;

    .bg {
      width : 100%;
      position: relative;
      img{
        width : 100%;
      }
      .person {
        position: absolute;
        width: 315px;
        height: 315px;
        border-radius: 315px;
        .pic_p {
          width: 100%;
        }
        .pic_w {
          width: 423px;
          height: auto;
          position: absolute;
          z-index: 2;
          top: -50px;
          left: -50px;
        }
      }
      .p1 {
        top: 137px;
        left: 180px;
      }
      .p2 {
        top: 246px;
        left: 588px;
      }

      .p3 {
        left: 990px;
        top: 150px;
      }
      .p4 {
        left: 1380px;
        top: 208px;
      }

      .text_box {
        width: 994px;
        height: 320px;
        background: url('../../assets/images/index/text.png');
        background-size: 100% 100%;
        position: absolute;
        top: 698px;
        left: 484px;

        .text-item {
          width: 100%;
          height: 100%;
          padding: 0 180px;
          .name {
            color: #fff;
            font-size: 26px;
            font-weight: 800;
            margin-top: 80px;
          }

          .text {
            color: #fff;
            font-size: 24px;
            line-height 42px;
            text-indent: 40px;
          }
        }
      }

      .line-sx {
        height: 365px;
        width: 200px;
        position: absolute;
        top: 483px;
        left: 314px;
        z-index: 5;
      }
      .line-yw {
        width: 30px;
        height: auto;
        position: absolute;
        top: 590px;
        left: 730px;
        z-index: 5;
      }
      .line-yy {
        width: 30px;
        height: auto;
        position: absolute;
        top: 500px;
        left: 1125px;
        z-index: 5;
      }
      .line-wl {
        width: 140px;
        height: auto;
        position: absolute;
        top: 530px;
        left: 1450px;
        z-index: 5;
      }
    }

    .bg2 {
      width : 1520px;
      height : 540px;
      margin: 0 auto;
      position: relative;
      img{
        width : 1520px;
        height : 540px;
      }
      margin-top: 20px;
      button {
        width: 150px;
        height: 45px;
        border-radius: 23px;
        background-color: #5c307d;
        font-size: 21px;
        color: #fff;
        position: absolute;
        bottom: 28px;
        left: 685px;
        border: none;
        cursor: pointer;
      }
    }

    .who {
      height: 480px;
      width: 1920px;
      
      .content {
        height: 480px;
        width: 1563px;
        margin: 0 auto;

        .label {
          width: 1563px;
          height: 120px;
          position: relative;
          float: left;

          .left {
            position: relative;
            float: left;
            height: 120px;
            width: 666.5px;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 656.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }

          .text {
            font-size: 44px;
            color: #5c307d;
            height: 120px;
            width: 230px;
            text-align: center;
            line-height: 120px;
            position: relative;
            float: left;
          }

          .right {
            position: relative;
            float: left;
            height: 60px;
            width: 666.5px;
            position: relative;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 655.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }
        }

        .major {
          height: 360px;
          width: 1520px;
          position: relative;
          float: left;

          .left {
            height: 360px;
            width: 470px;
            float: left;
            position: relative;
            img{
              height : 300px;
            }
          }

          .middle {
            height: 350px;
            width: 540px;
            float: left;
            position: relative;
            padding-left : 10px;

            .text {
              color: #585858;
              font-size: 20px;
              letter-spacing : 2px;
              width: 540px;
              height: 280px;
              word-wrap: break-word;
              word-break: break-all;
              text-indent: 35px;
            }
          }

          .right {
            height: 360px;
            width: 470px;
            float: left;
            position: relative;
            img{
              height : 330px;
              margin-top : -22px;
            }
          }
        }
      }
    }

    .zhl {
      height: 780px;
      width: 1920px;
      position: relative;
      background-color : #efefef;
      .content {
        position: relative;
        height: 780px;
        width: 1563px;
        margin-left: 178.5px;
        .label {
          width: 1563px;
          height: 120px;
          position: relative;
          float: left;

          .left {
            position: relative;
            float: left;
            height: 120px;
            width: 581.5px;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 571.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }

          .text {
            font-size: 44px;
            color: #5c307d;
            height: 120px;
            width: 400px;
            text-align: center;
            line-height: 120px;
            position: relative;
            float: left;
          }

          .right {
            position: relative;
            float: left;
            height: 60px;
            width: 581.5px;
            position: relative;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 571.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }
        }
        .first{
          color: #585858;
          font-size: 20px;
          letter-spacing : 2px;
          width: 1520px;
          height: 110px;
          word-wrap: break-word;
          word-break: break-all;
          line-height : 110px;
          position : relative;
          float : left;
          text-align : center;
        }
        .person{
          height : 360px
          width : 1520px;
          position : relative;
          float : left;
          .item{
            width : 500px;
            height : 360px;
            position : relative;
            float : left;
            padding-left : 70px;
            .picture{
              height : 255px;
              width : 370px;
              position : relative;
              float : left;
              img{
                height : 255px;
                width : 370px;
              }
            }
            .introduce{
              width : 370px;
              height : 105px;
              position : relative;
              float : left;
              .identity{
                height : 55px;
                width : 370px;
                font-size : 20px;
                line-height : 75px;
                text-align : center;
                letter-spaceing : 2px;
                color : #5c407d;
              }
              .other{
                height : auto;
                width : 370px;
                font-size : 16px;
                line-height : 25px;
                color : #585858;
                text-align : center;
                letter-spaceing : 2px;
                white-space : warp;
              }
            }
          }
        }
        .bottom{
          text-align : left;
          text-indent : 50px;
          font-size : 20px;
          letter-spacing : 2px;
          color : #585858;
          position : relative;
          float : left;
          margin-top : 50px;
          height : 140px;
          width : 1520px;
          line-height : 30px;
        }
      }
    }

    .export{
      width : 1920px;
      height : 870px;
      position : relative;
      float : left;
      .content{
        position: relative;
        height: 870px;
        width: 1563px;
        margin-left: 178.5px;
        .label {
          width: 1563px;
          height: 120px;
          position: relative;
          float: left;

          .left {
            position: relative;
            float: left;
            height: 120px;
            width: 561.5px;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 551.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58.5px;
            }
          }

          .text {
            font-size: 44px;
            color: #5c307d;
            height: 120px;
            width: 440px;
            text-align: center;
            line-height: 120px;
            position: relative;
            float: left;
          }

          .right {
            position: relative;
            float: left;
            height: 60px;
            width: 561.5px;
            position: relative;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 551px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58.5px;
            }
          }
        }
        .first{
          color: #585858;
          font-size: 20px;
          width: 1520px;
          height: 110px;
          word-wrap: break-word;
          word-break: break-all;
          line-height :30px;
          position : relative;
          float : left;
          letter-spaceing : 2px;
          text-indent : 50px;
        }
        .picture{
          width : 1300px;
          height : 570px;
          margin-left : 100px;
          img{
            width : 1300px;
            height : 570px;
          }
        }
      }
    }

    .user{
      width : 1920px;
      height : 870px;
      position : relative;
      float : left;
      background-color : #efefef;
      .content{
        position: relative;
        height: 870px;
        width: 1563px;
        margin-left: 178.5px;
        .label {
          width: 1563px;
          height: 120px;
          position: relative;
          float: left;

          .left {
            position: relative;
            float: left;
            height: 120px;
            width: 666.5px;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 656.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }

          .text {
            font-size: 44px;
            color: #5c307d;
            height: 120px;
            width: 230px;
            text-align: center;
            line-height: 120px;
            position: relative;
            float: left;
          }

          .right {
            position: relative;
            float: left;
            height: 60px;
            width: 666.5px;
            position: relative;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 656.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }
        }
        .first{
          color: #585858;
          font-size: 20px;
          width: 1520px;
          height: 110px;
          word-wrap: break-word;
          word-break: break-all;
          line-height :30px;
          position : relative;
          float : left;
          letter-spaceing : 2px;
          text-align : center;
          text-indent : 50px;
        }
        .picture{
          width : 1300px;
          height : 570px;
          margin-left : 200px;
          img{
            width : 1000px;
            height : 570px;
          }
        }
      }
    }

    .advantage {
      height: 540px;
      width: 1920px;
      position: relative;
      background-color : #ffffff;
      float : left;
      .content {
        position: relative;
        height: 540px;
        width: 1563px;
        margin-left: 178.5px;
        float : left;
        .label {
          width: 1563px;
          height: 120px;
          position: relative;
          float: left;

          .left {
            position: relative;
            float: left;
            height: 120px;
            width: 641.5px;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 631.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }

          .text {
            font-size: 44px;
            color: #5c307d;
            height: 120px;
            width: 280px;
            text-align: center;
            line-height: 120px;
            position: relative;
            float: left;
          }

          .right {
            position: relative;
            float: left;
            height: 60px;
            width: 641.5px;
            position: relative;

            .line {
              position: relative;
              float: left;
              height: 65px;
              width: 631.5px;
              border-bottom: 2px #5c307d solid;
            }

            .point {
              height: 10px;
              width: 10px;
              border-radius: 10px;
              background-color: #5c307d;
              float: left;
              position: relative;
              margin-top: 58px;
            }
          }
        }
        .person{
          height : 420px
          width : 1520px;
          position : relative;
          float : left;
          .item{
            width : 380px;
            height : 320px;
            position : relative;
            float : left;
            padding-left : 70px;
            .picture{
              height : 270px;
              width : 270px;
              position : relative;
              float : left;
              img{
                height : 270px;
                width : 270px;
              }
            }
            .introduce{
              width : 270px;
              height : 105px;
              position : relative;
              float : left;
              .identity{
                height : 55px;
                width : 270px;
                font-size : 20px;
                line-height : 75px;
                text-align : center;
                color : #5c407d;
                letter-spaceing : 2px;
              }
              .other{
                height : 25px;
                width : 270px;
                font-size : 18px;
                line-height : 25px;
                color : #585858;
                letter-spaceing : 2px;
                text-align : center;
              }
            }
          }
        }
      }
    }

    .number{
      width : 1920px;
      height : 390px;
      background-color : #efefef;
      position: relative;
      float : left;
      margin : 0 auto;
      display : flex;
        justify-content :center;
      .content{
        width : 1200px;
        height : 390px;
        background-color : #efefef;
        position: relative;
        float : left;
        margin : 0 auto;
        display : flex;
        justify-content :space-between;
        .item{
        width : 150px;
        height : 100px;
        position: relative;
        float : left;
        padding-top : 120px;
        .top{
          height : 75px;
          width : 150px;
          color : #5c307d;
          font-size : 50px;
          position: relative;
          float : left;
          text-align : center;
          font-weight :700;
          float : left;
          span{
            font-size:25px;
          }
        }
        .bottom{
          height : 75px;
          width : 150px;
          color : #585858;
          font-size : 20px;
          position: relative;
          float : left;
          text-align : center;
        }
      }

      }
      

    }
    
    /deep/ .el-dialog {
      width: 600px;
    }

    /deep/ .dialog_visible {
      height: auto;
      .el-form {
        .el-form-item {
          margin-bottom : 20px;
          .el-form-item__label {
            font-size: 18px;
            color: #aaaaaa;
            text-align: center;
            height: 48px;
            line-height: 48px;
          }

          .el-form-item__content {
            .el-input {
              width: 337px;
              height: 48px;
              float : left;
              input {
                background-color: #f7f7f7;
                border-radius: 50px;
                height: 48px;
                font-size: 18px;
                color: #585858;
                float : left;
              }
              .el-icon-circle-check{
                  color : green;
              }
              
            }
            .getcode{
                position : relative;
                float : left;
                padding-left: 10px;
                padding-top : 2px;
                font-size : 18px;
            }

            .el-radio-group {
              width: 337px;
              margin-left: 90px;
              margin-top: 50px;

              .el-radio__label {
                color: #585858;
                font-size: 19px;
              }

              .el-radio__input {
                cursor: pointer;
                vertical-align: middle;
                width: 20px;
                height: 20px;
              }
            }

            .el-checkbox {
              margin-left: 110px;

              .el-checkbox__label {
                color: #aaaaaa;
              }
            }

            a {
              color: #5c307d;
              margin-left: 0px;
            }

            .el-checkbox-group {
              .el-checkbox {
                float: left;
                margin-left: 7%;
              }

              .el-checkbox__label {
                font-size: 14px;
                color: #585858;
              }
            }

            .el-form-item__error{
              color: #F56C6C;
              font-size: 14px;
              line-height: 1;
              padding-top: 0;
              position: absolute;
              top: 100%;
              left: 0;
            }
          }
        }
      }

      .el-button {
        width: 337px;
        height: 48px;
        text-align: center;
        line-height: 0px;
        
        border-radius: 50px;
        font-size: 21px;
        color: #ffffff;
        margin-top: 0px;
        
      }
    }

    .csoa {
      width: 337px;
      height: 190px;
      position: relative;
      background-color: #f7f7f7;

      .tip {
        width: 337px;
        height: 65px;
        font-size: 19px;
        color: #585858;
        text-align: center;
        line-height: 65px;
        border-bottom: 1px #585858 solid;
      }
    }
  }
  .foot{
      width : 1920px;
      height : 260px;
      background-color : #5c307d;
      position: relative;
      float : left;
      .content{
        height : 260px;
        width : 1563px;
        margin : 0 auto;
        .left{    
        height : 260px;
        position : relative;
        float : left;
        .logo{
          width : 200px;
          padding-top : 30px;
          img{
            width : 200px;
          }
        }
        .name{
          font-size : 22px;
          color : #ffffff;
          text-align : left;
          padding-top : 50px;
        }
        .copyright{
          padding-top : 20px;
          font-size : 16px;
          color : #ffffff;
          text-align : left;
        }
      }
      .right{
        width : 120px;
        height : 190px;
        position: relative;
        float : right;
        padding-top : 50px;
        .qrcode{
          width : 120px;
          height : 120px;
          position: relative;
          float : left;
          img{
            width : 120px;
            height : 120px;
          }
        }
        .text{
          padding-top : 10px;
          width : 120px;
          height : 60px;
          position: relative;
          float : left;
          p{
            color : #ffffff;
            font-size : 16px;
            text-align : center;
          }
        }

      }
      }
      
    }
}
</style>
